var App = App || {};

App.Blog = (function ($) {
    'use strict';

    function Featured() {
        const featured = $(".component-blog__featured");
        featured.ZagScrollAnimate({
            targets: [
                { selector: ".component-blogPost__animate", type: "animate__fadeInLeft", stagger: 0 }
            ]
        });
    }

    function List() {
        const list = $(".component-blog__list");
        list.ZagScrollAnimate({
            targets: [
                { selector: ".component-blogPost", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    function Masthead() {

        const masthead = $(".component-blogPost--masthead");
        masthead.ZagScrollAnimate({
            targets: [
                { selector: ".component-blogPost__animate", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    function Related() {

        const carousel = $(".component-blogPost--related .component-blogPost--related__grid.splide");
        const counterCurrent = carousel.find("[data-splide-counter=\"current\"]");
        const counterTotal = carousel.find("[data-splide-counter=\"total\"]");
        const progress = carousel.find("[data-splide-progress]");

        if (carousel.length) {

            const options = {
                type: 'slide',
                rewind: true,
                speed: 500,
                arrows: true,
                pagination: false,
                autoWidth: true
            }

            const splide = new Splide(carousel[0], options);

            splide.on('overflow', function (isOverflow) {
                splide.go(0);

                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                    clones: isOverflow ? undefined : 0,
                    label: "Related Blog Posts Carousel"
                };

                carousel.toggleClass("is-carousel", isOverflow);
            });

            splide.on('move', function (newIndex) {
                counterCurrent.html(newIndex + 1);
                progress.css({ left: `${100 / splide.length * (newIndex)}%` });
            });

            splide.on('mounted', function () {
                RelatedAnimate(carousel);
                counterCurrent.html(splide.index + 1);
                counterTotal.html(splide.length);
                progress.width(`${100 / splide.length}%`);
            });

            splide.mount();
        }
    }

    function RelatedAnimate(carousel) {
        carousel.ZagScrollAnimate({
            targets: [
                { selector: ".component-blogPost--related__items", type: "animate__fadeInLeft" }
            ]
        });
    }

    return {
        Featured: Featured,
        List: List,
        Masthead: Masthead,
        Related: Related
    };

})(jQuery);